module.exports = __webpack_public_path__ + "img/varvara-rao.79b2f147.jpg";